import React, { useEffect, useState } from "react";
import { XMarkIcon } from '@heroicons/react/24/outline'
import { isAndroid, isIOS, isMobile, isTablet, isBrowser, browserName } from 'react-device-detect';
import { set } from "date-fns";




export const PopUp = ({ visible, setVisible, handleAgregar, handleClose, installEvent, isStandalone }) => {





    useEffect(() => {

        const lastShown = localStorage.getItem("agregarAccesoDirectoFecha");
        console.log("lastShown", lastShown)
        const now = new Date();


        if (isMobile) {
            setVisible(true);
            if (!lastShown) {
                setVisible(true);
            } else {
                const diffDays = (now - new Date(lastShown)) / (1000 * 60 * 60 * 24);
                if (diffDays <= 30) {
                    setVisible(false);
                }
            }
        }

        /*
                if (isMobile) {
                    alert("es un movil")
                    if (isIOS) {
                        alert("es un es un iphone")
                    }
                }
        */


    }, []);






    return (
        isMobile &&
        visible &&
        !isStandalone &&
        ((isAndroid && installEvent) || isIOS) && (

            < div className="pl-4 pr-4 z-2" style={styles.container} >



                <div className=" popup__modal shadow-xl shadow-[#000] rounded-2xl dark:bg-[#0f0f0f]  ring-4 ring-outset ring-[#3d3838]">
                    <button
                        type="button"
                        onClick={handleClose}
                        style={styles.closeButton}
                    >
                        <span className="sr-only">Cerrar</span>
                        <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
                    </button>

                    <p style={styles.text} className="text-center mt-3">
                        {isIOS &&
                            <>Para agregar esta App a tu pantalla de inicio en iPhone o iPad, abrí el menú de <strong>Compartir</strong> (ícono con flecha hacia arriba) y elegí <strong>“Agregar a pantalla de inicio”</strong>.</>
                        }
                        {isAndroid &&
                            <>¿Querés agregar un acceso directo?
                                <button
                                    className="m-auto flex mt-3 justify-center rounded-md bg-[#b70100] px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-[#d40000] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#ED1C24]"
                                    onClick={handleAgregar}>
                                    Agregar acceso directo
                                </button>
                            </>
                        }
                    </p>

                </div>
            </div >
        )
    );

};

const styles = {
    container: {
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100vw",
        color: "#fff",
        zIndex: 9999,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    },
    closeButton: {
        position: "absolute",
        top: 8,
        right: 20,
        background: "transparent",
        border: "none",
        cursor: "pointer",
    },

};
